/* eslint-disable jira/naming/disallow-filenames */
export const getApiPrefix = () => 'gateway/api/jira/project-configuration';
